import hero from './hero/data'
import numberedInfoList from './numbered-info-list/data'
import productBlocks from './product-blocks/data'

export default {
  sv: [
    hero.sv,
  ],
  nb: [
    hero.nb,
    productBlocks.nb,
    numberedInfoList.nb,
  ],
  fi: [
    hero.fi,
    productBlocks.fi,
    numberedInfoList.fi,
  ],
}
